import axios from 'axios';

import config from '@/config/config';
import { headers } from './auth.headers';
import { formatQueryString } from '@/helpers/query-string';
import { ITypeMedia } from '@/domain/type-media.model';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';

const url_api_base = config.url_api_base;

export const insert = (data: ITypeMedia): Promise<ITypeMedia> => {
  return axios.post(`${url_api_base}/type-media`, data, headers());
};

export const update = (data: ITypeMedia): Promise<ITypeMedia> => {
  return axios.patch(`${url_api_base}/type-media/${data.id}`, data, headers());
};

export const get = (id: string): Promise<ITypeMedia> => {
  const url = `${url_api_base}/type-media/${id}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const list = (
  offset?: number,
  limit?: number,
  order?: string,
  sort?: string,
  filter?: string,
): Promise<IPaginateVueTable<ITypeMedia>> => {
  const query = formatQueryString(offset, limit, order, sort, filter);
  const url = `${url_api_base}/type-media${query}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const listActive = (): Promise<ITypeMedia[]> => {
  const url = `${url_api_base}/type-media/list-active`;

  return axios.get(url, headers()).then((res) => res?.data);
};
